import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ContentCopyIcon from '@mui/icons-material/ContentCopyOutlined'
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Link,
  TextField,
  Tooltip,
} from '@mui/material'
import esocialImage from 'assets/brazil-stamp.svg'
import logoImage from 'assets/logo-icon.png'
import ImageBanner from 'components/image-banner'
import SecuritySVG from 'components/svg/security'
import WrapperPermission from 'components/wrapper-permission'
import { useStyles } from './styles'
import useComponent from './use-component'

const LetterOfAttorneyEsocial = () => {
  const classes = useStyles()

  const {
    isSubmitting,
    isDisabled,
    register,
    onSubmit,
    setIsDisabled,
    handleBack,
    handleClick,
    handleChange,
    handleNavigateToECAC,
  } = useComponent()

  return (
    <Box className={classes.container}>
      <Box className={classes.mainWrapper}>
        <WrapperPermission>
          <Box className={classes.connectBox}>
            <Box
              display='flex'
              alignItems='center'
            >
              <img
                src={logoImage}
                alt='Conducco'
                className={classes.logoImage}
              />
              <ArrowForwardIcon style={{ color: '#707974' }} />
              <img
                src={esocialImage}
                alt='E-Social'
                height={48}
                style={{ marginLeft: '12px' }}
              />
            </Box>

            <p className={classes.formTitle}>Conectar com eSocial</p>
            <p className={classes.formSubTitle}>
              Conecte seus dados do eSocial ao seu Cofre Digital da Conducco por meio de uma <b>Procuração e-CAC</b>.
            </p>

            <Box
              component='form'
              noValidate
              data-testid='form'
              className={classes.formBox}
              marginTop='16px'
            >
              <p className={classes.formSubTitle}>
                <b>Crie uma procuração</b>
              </p>
              <p className={classes.formSubTitle}>
                Para conectar ao eSocial por meio de uma procuração, acesse o e-CAC e crie uma nova procuração,
                concedendo à Conducco o direito de coletar os dados para armazenamento em sua nuvem privada.
                <Link
                  href='https://youtu.be/PqynYXwSKSA'
                  target='_blank'
                  style={{ color: '#3024E1', textDecoration: 'none' }}
                >
                  {' '}
                  Veja como criar uma procução
                </Link>
              </p>

              <Button
                onClick={handleNavigateToECAC}
                variant='outlined'
                sx={{
                  marginTop: 2,
                  marginBottom: 4,
                  padding: '0 2rem',
                  height: '42px',
                  fontWeight: '600',
                }}
              >
                Ir para o e-CAC
              </Button>

              <TextField
                id='cnpjConducco'
                type='text'
                autoFocus
                variant='outlined'
                value='44.589.010/0001-80'
                label='CNPJ Conducco para Procuração'
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position='end'>
                      <Tooltip
                        title='Copiar CNPJ para a memória'
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: 'common.black',
                            },
                          },
                        }}
                      >
                        <IconButton
                          edge='end'
                          onClick={(e) => handleClick('44.589.010/0001-80')}
                        >
                          <ContentCopyIcon />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e) => setIsDisabled(!e.target.checked)}
                    disabled={isSubmitting}
                    sx={{
                      mt: '-50px',
                      borderColor: '#0f0f1e !important',
                      opacity: 0.6,
                    }}
                  />
                }
                label={
                  <div className={classes.acceptArea}>
                    <span>
                      Eu autorizo a Conducco a coletar dados em meu nome na base do eSocial. Li e concordo com os{' '}
                      <Link
                        download
                        href='/documents/Termose_Condicoes_Conducco-10_01_2024.pdf'
                        className={classes.link}
                      >
                        Termos de Uso
                      </Link>{' '}
                      e a{' '}
                      <Link
                        download
                        href='/documents/Politica_Privacidade.pdf'
                        className={classes.link}
                      >
                        Política de Privacidade
                      </Link>{' '}
                      da Conducco
                    </span>
                  </div>
                }
                {...register('acceptance', {
                  onChange: (e) => handleChange(e),
                })}
              />

              <Box
                display='flex'
                flexDirection='column'
                gap='1rem'
                alignItems='center'
                width='100%'
              >
                <Button
                  variant='contained'
                  type='submit'
                  size='large'
                  fullWidth
                  onClick={onSubmit}
                  disabled={isSubmitting || isDisabled}
                  sx={{
                    mt: 2,
                    mb: 0,
                    '&.Mui-disabled': {
                      backgroundColor: '#8C9097 !important',
                      color: '#FFF !important',
                    },
                  }}
                >
                  {isSubmitting ? (
                    <CircularProgress
                      color='inherit'
                      size={26}
                    />
                  ) : (
                    'CONECTAR'
                  )}
                </Button>

                <Button
                  onClick={handleBack}
                  variant='text'
                  color='inherit'
                >
                  <ChevronLeftIcon sx={{ mr: '8px', fontSize: '24px' }} />
                  Voltar
                </Button>
              </Box>
            </Box>
          </Box>
        </WrapperPermission>

        <ImageBanner
          title='A Conducco garante a privacidade e a segurança dos seus dados, seguindo rigorosos padrões de proteção.'
          banner={<SecuritySVG />}
        />
      </Box>
    </Box>
  )
}

export default LetterOfAttorneyEsocial
